import React from "react";
import { Box, Chip, Stack, Tab, Tabs, Typography } from "@mui/material";
import AdminPanelSettingsRoundedIcon from "@mui/icons-material/AdminPanelSettingsRounded";

/**
 * 결재 관리자 모드의 화면 전환 — 탭.
 *
 * <h3>왜 버튼이 아니라 탭인가</h3>
 * <p>예전에는 «전체 결재 현황» 헤더 우측의 버튼 두 개(프로젝트 연결 · 결재 양식 관리)가 화면을
 * 통째로 갈아끼웠고, 돌아오려면 각 화면의 «← 전체 결재 현황» 을 눌러야 했다. 관리자 모드에 세 화면이
 * 나란히 있다는 사실이 어디에도 안 보여서, 특히 «프로젝트 연결» 은 들어가 본 사람만 아는 화면이었다.
 * 프로젝트 미연결 결재는 방치하면 프로젝트별 취합에서 조용히 빠지므로, 있다는 것 자체가 보여야 한다.
 *
 * <h3>미연결 건수를 라벨에 붙이는 이유</h3>
 * <p>탭을 열어 봐야 «할 일이 있는지» 알 수 있으면 아무도 안 연다. 0건이면 배지를 아예 안 그려
 * «남은 게 있을 때만» 눈에 띄게 한다.
 *
 * @param {"approvals"|"projects"|"forms"} value 현재 화면
 * @param {Function} onChange  (next) => void
 * @param {number}   unlinkedCount 프로젝트 미연결 결재 건수 (0이면 배지 숨김)
 * @param {Function} onExitAdmin 관리자 모드 종료
 */
export default function ApprovalAdminTabs({ value, onChange, unlinkedCount = 0, onExitAdmin }) {
    const TABS = [
        { key: "approvals", label: "전체 결재 현황" },
        { key: "projects",  label: "프로젝트 연결", badge: unlinkedCount },
        { key: "forms",     label: "결재 양식 관리" },
    ];
    const idx = Math.max(0, TABS.findIndex(t => t.key === value));

    return (
        <Box>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.5 }}>
                <Box onClick={onExitAdmin} sx={{ fontSize: 12, color: "#2563eb", cursor: "pointer", fontWeight: 600 }}>
                    ← 일반 모드
                </Box>
                <AdminPanelSettingsRoundedIcon sx={{ fontSize: 18, color: "#2563eb" }} />
                <Typography sx={{ fontWeight: 800, fontSize: 18, color: "#0f172a" }}>결재 관리자</Typography>
            </Stack>

            <Box sx={{ borderBottom: "1px solid #e2e8f0" }}>
                <Tabs
                    value={idx}
                    onChange={(_, i) => onChange(TABS[i].key)}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{ minHeight: 38, "& .MuiTab-root": { minHeight: 38, fontSize: 13, fontWeight: 700, textTransform: "none" } }}
                >
                    {TABS.map(t => (
                        <Tab key={t.key} label={
                            <Stack direction="row" alignItems="center" spacing={0.75}>
                                <span>{t.label}</span>
                                {t.badge > 0 && (
                                    <Chip label={t.badge} size="small" sx={{
                                        height: 17, minWidth: 17, fontSize: 10.5, fontWeight: 800,
                                        bgcolor: "#fef3c7", color: "#b45309",
                                        "& .MuiChip-label": { px: 0.6 },
                                    }} />
                                )}
                            </Stack>
                        } />
                    ))}
                </Tabs>
            </Box>
        </Box>
    );
}
